import styled, { css } from "styled-components";

export const TestimonialCard = styled.div`
  background: linear-gradient(135deg, rgba(20, 20, 30, 0.95) 0%, rgba(30, 30, 45, 0.9) 100%);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 24px;
  padding: 60px 80px;
  max-width: 900px;
  margin: 0 auto;
  position: relative;
  backdrop-filter: blur(20px);

  @media (max-width: 768px) {
    padding: 40px 24px;
    border-radius: 16px;
  }
`;

export const QuoteMark = styled.div`
  position: absolute;
  top: 30px;
  left: 50px;
  font-size: 140px;
  font-family: Georgia, serif;
  background: linear-gradient(135deg, rgba(245, 217, 204, 0.3) 0%, rgba(167, 139, 250, 0.2) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  line-height: 1;
  user-select: none;

  @media (max-width: 768px) {
    top: 15px;
    left: 20px;
    font-size: 80px;
  }
`;

export const QuoteText = styled.p`
  font-size: 1.625rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.7;
  text-align: center;
  margin: 0 0 36px 0;
  position: relative;
  z-index: 1;
  letter-spacing: -0.01em;

  .highlight {
    background: linear-gradient(135deg, #F5D9CC 0%, #D9442B 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    font-weight: 600;
  }

  @media (max-width: 768px) {
    font-size: 1.125rem;
    margin-bottom: 24px;
  }
`;

export const AuthorInfo = styled.div`
  text-align: center;
  margin-bottom: 48px;

  @media (max-width: 768px) {
    margin-bottom: 32px;
  }
`;

export const AuthorName = styled.span`
  font-size: 1rem;
  font-weight: 600;
  color: #ffffff;
  letter-spacing: 0.02em;
`;

export const AuthorTitle = styled.span`
  font-size: 0.9375rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.5);
  margin-left: 8px;
`;

export const AvatarRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
`;

interface AvatarProps {
  isActive: boolean;
}

export const Avatar = styled.button<AvatarProps>`
  width: ${props => props.isActive ? '52px' : '42px'};
  height: ${props => props.isActive ? '52px' : '42px'};
  border-radius: 14px;
  overflow: hidden;
  border: ${props => props.isActive ? '2px solid #F5D9CC' : '1px solid rgba(255, 255, 255, 0.1)'};
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: rgba(255, 255, 255, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  opacity: ${props => props.isActive ? 1 : 0.5};

  &:hover {
    opacity: 1;
    border-color: rgba(245, 217, 204, 0.5);
    transform: translateY(-2px);
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (max-width: 768px) {
    width: ${props => props.isActive ? '44px' : '36px'};
    height: ${props => props.isActive ? '44px' : '36px'};
    border-radius: 10px;
  }
`;

export const PlaceholderAvatar = styled.div`
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(245, 217, 204, 0.2) 0%, rgba(167, 139, 250, 0.2) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 500;
  font-size: 0.875rem;
  letter-spacing: 0.05em;
`;

// Legacy exports for compatibility
interface StyleProps {
  isMobile: boolean;
}

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const TestimonialContainer = styled.div`
  margin: 24px;
`;

export const Text = styled.p<StyleProps>(({isMobile}: StyleProps)=>css`
  font-size: ${isMobile? '18px' : '24px'};
  text-align: center;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.7;
`);

export const AuthorText = styled(Text)`
  font-weight: 600;
  text-align: center;
  color: #D9442B;
  margin-top: 24px;
`;

export const ArrowGroup = styled.div`
  display: flex;
  justify-content: center;
`;

export const PrevArrow = styled.img<StyleProps>(
  ({ isMobile }: StyleProps) => css`
    border-radius: 50%;
    width: ${isMobile? '25px' : '50px'};
    cursor: pointer;
    margin: ${isMobile ? '0 12px' : '0 24px'};
    border: ${isMobile ? '2px solid rgba(255, 255, 255, 0.3)' : 'none'};
    padding: ${isMobile ? '12px' : '0px'};
    filter: invert(1);
    opacity: 0.7;
    transition: opacity 0.2s ease;

    &:hover {
      opacity: 1;
    }
  `
);

export const NextArrow = styled(PrevArrow)`
  transform: rotate(180deg);
`;
